export default __webpack_public_path__ + "static/media/footer_stiker.257e65d6.png";